import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import CoachEventCard from './coach-event-card'
import { GROUP_EVENT_PAGE_LIMIT } from 'lib/pga-dot-coach'
import TablePagination from 'components/pagination/table-pagination'
import { RefetchContext } from 'lib/utils/refetchContext'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '45px',
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
      marginBottom: '70px',
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
  },
}))

const EventsDisplay = ({
  events,
  totalEvents,
  advancePagination,
  retreatPagination,
  currentPage,
  lastPage,
}) => {
  const classes = useStyles()
  const refetch = useContext(RefetchContext)
  const page = currentPage - 1
  const pageItemCount = events.length
  const hasMorePages = !lastPage && totalEvents === GROUP_EVENT_PAGE_LIMIT
  const pageCount = hasMorePages ? page + 2 : page + 1
  const showPagination = pageCount > 1 || page > 0

  const handlePageChange = nextPage => {
    if (nextPage > page) {
      advancePagination()
      return
    }

    if (nextPage < page) {
      retreatPagination()
    }
  }

  return (
    <Box className={classes.root}>
      <Grid container spacing={4}>
        {events.map(event => (
          <Grid
            key={event.id}
            item
            lg={4}
            md={6}
            sm={12}
            style={{ width: '100%' }}
          >
            <CoachEventCard event={event} onPayment={refetch} />
          </Grid>
        ))}
      </Grid>
      {showPagination ? (
        <Box className={classes.pagination} data-testid="events-display">
          <TablePagination
            page={page}
            pageCount={pageCount}
            rowsPerPage={null}
            totalCount={Math.max(pageItemCount, 1)}
            onPageChange={handlePageChange}
          />
        </Box>
      ) : null}
    </Box>
  )
}

export default EventsDisplay

EventsDisplay.propTypes = {
  events: PropTypes.array.isRequired,
  totalEvents: PropTypes.number.isRequired,
  advancePagination: PropTypes.func.isRequired,
  retreatPagination: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  lastPage: PropTypes.bool.isRequired,
}
